export default {
  'auth_index': {
    path: '/auth',
    redirect: {name: 'user_login'}
  },
  'user_login': {
    parentPath: 'auth_index',
    path: '/login',
  },
  'user_register': {
    parentPath: 'auth_index',
    path: '/register'
  },
  'user_register_org': {
    parentPath: 'auth_index',
    path: '/register/org'
  },
  'user_verify_mobile': {
    parentPath: 'auth_index',
    path: '/register/verify/mobile'
  },
  'user_school_register': {//学校手机验证
    parentPath: 'auth_index',
    path: '/register/school/verify/mobile'
  },
  'user_forgetpwd': {
    parentPath: 'auth_index',
    path: '/forgetpwd'
  },
  'user_index': {
    parentPath: 'auth_index',
    path: '/user/index',
    meta: {
      login: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Auth/route.config.js